import { combineReducers } from "redux";
import { dEmployees } from "./dEmployees";

export const reducers = combineReducers({
    dEmployees
})